import baseApi from 'api/baseApi';
import { IRequestOptions } from 'common/interfaces/dictionary';
import { IPaginatedData } from 'common/interfaces/pagination';
import { IEmployeeBasicInfo } from 'interfaces/employee.interfaces';

const dictionaryApi = baseApi.injectEndpoints({
  endpoints: builder => ({
    getSalespersons: builder.query<IPaginatedData<IEmployeeBasicInfo>, IRequestOptions | void>({
      query: (options?: IRequestOptions) => ({
        url: '/api/v1/dictionary/salespersons',
        method: 'GET',
        params: options,
      }),
    }),
  }),
});

export const {
  useGetSalespersonsQuery: useGetSalespersons,
  useLazyGetSalespersonsQuery: useLazyGetSalespersons,
} = dictionaryApi;

export default dictionaryApi;
